export default {
  path: 'oem',
  component: () => import( /* webpackChunkName: "roles-list" */ '@/pages/oem/OemList'),
  meta: {
    title: 'OEM申请'
  },
  children: [{
      path: 'create',
      component: () => import( /* webpackChunkName: "company-create" */ '@/pages/oem/CreateEdit'),
      meta: {
        title: '添加oem'
      },
    },
    {
      path: ':company_id/edit',
      component: () => import( /* webpackChunkName: "company-edit" */ '@/pages/oem/CreateEdit'),
      meta: {
        title: '编辑oem'
      },
    },
  ]
}